import t from 'tcomb';
import Style_Distance from '../Style_Distance';

const Margin_Bottom_Style = t.struct({
  'margin-bottom': t.maybe(Style_Distance)
}, 'Margin_Bottom_Style');

module.exports = Margin_Bottom_Style;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/style/Margin_Bottom_Style.js
 **/